import { CanActivateFn, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode'; // ✅ RIGHT
import { inject } from '@angular/core';

interface JwtPayload {
  exp: number;
  [key: string]: any;
}

export const authGuard: CanActivateFn = (route, state) => {
  const token = sessionStorage.getItem('token');
  const router = inject(Router);

  if (!token) {
    router.navigate(['']);
    return false;
  }

  try {
    const decoded = jwtDecode<JwtPayload>(token);
    const now = Math.floor(Date.now() / 1000);

    if (decoded.exp && decoded.exp < now) {
      console.warn('🚫 Token expired');
      sessionStorage.removeItem('token');
      router.navigate(['']);
      return false;
    }

    return true;
  } catch (err) {
    console.error('❌ Invalid token:', err);
    router.navigate(['']);
    return false;
  }
};
